/* eslint-disable react/prop-types */
import { useState } from "react";
import { alpha } from "@mui/material";
import { Box, Collapse, IconButton, Link as MuiLink, } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import { Link as RouterLink, useLocation } from "react-router-dom";
import Logo from "../Logo";
import { BlackLogo, NAV_LINKS } from "../../consts";
import React from "react";
export default function SiteHeader({ menuOpen: controlledMenuOpen, onMenuToggle, hideMobileNav = false, hideLogo = false, }) {
    const location = useLocation();
    const [internalMenuOpen, setInternalMenuOpen] = useState(false);
    const isControlled = controlledMenuOpen !== undefined && onMenuToggle !== undefined;
    const menuOpen = isControlled ? controlledMenuOpen : internalMenuOpen;
    const toggleMenu = isControlled
        ? onMenuToggle
        : () => setInternalMenuOpen((open) => !open);
    const closeMenu = () => {
        if (isControlled)
            onMenuToggle();
        else
            setInternalMenuOpen(false);
    };
    return (React.createElement(Box, { component: "header", sx: (theme) => ({
            width: "100%",
            height: { xs: 76, md: 92 },
            px: 0,
            position: "relative",
            zIndex: 100,
            overflow: "visible",
            bgcolor: "background.paper",
            background: `linear-gradient(
          to bottom,
          ${theme.palette.background.paper} 0%,
          ${theme.palette.background.default} 95%,
          ${alpha(theme.palette.background.default, 0)} 100%
        )`,
        }) },
        React.createElement(Box, { sx: {
                width: "100%",
                maxWidth: 1500,
                height: "100%",
                mx: "auto",
                px: 0,
                display: "flex",
                alignItems: "center",
                overflow: "visible",
            } },
            !hideLogo && location.pathname !== "/" && (React.createElement(Logo, { fileName: BlackLogo, sx: {
                    width: { xs: 130, sm: 155, md: 195 },
                    height: "auto",
                    transform: { xs: "translateY(5px)", md: "translateY(20px)" },
                } })),
            React.createElement(Box, { sx: { display: "flex", alignItems: "center", ml: "auto" } },
                React.createElement(Box, { sx: {
                        display: { xs: "none", md: "flex" },
                        flexWrap: "wrap",
                        justifyContent: "flex-end",
                        gap: { xs: 2.5, sm: 3.5, md: 4 },
                    } }, NAV_LINKS.map((link) => (React.createElement(MuiLink, { component: RouterLink, key: link.to, to: `/${link.to}`, sx: {
                        py: 1.75,
                        fontFamily: "'Jost', sans-serif",
                        fontSize: "0.72rem",
                        fontWeight: 500,
                        letterSpacing: "0.14em",
                        textTransform: "uppercase",
                        textDecoration: "none",
                        color: "primary.main.dark",
                        borderBottom: "2px solid",
                        borderColor: "divider",
                    } }, link.label)))),
                React.createElement(IconButton, { onClick: toggleMenu, "aria-label": menuOpen ? "Close navigation menu" : "Open navigation menu", sx: { display: { xs: "flex", md: "none" }, p: 0.75 } }, menuOpen ? React.createElement(CloseIcon, null) : React.createElement(MenuIcon, null)))),
        !hideMobileNav && (React.createElement(Collapse, { in: menuOpen },
            React.createElement(Box, { component: "nav", sx: {
                    display: { xs: "flex", md: "none" },
                    flexDirection: "column",
                    px: 3,
                    pb: 3,
                    borderTop: "1px solid rgba(27, 24, 18, 0.08)",
                } }, NAV_LINKS.map((link) => (React.createElement(Box, { key: link.to, component: RouterLink, to: `/${link.to}`, onClick: closeMenu, sx: {
                    py: 1.75,
                    fontFamily: "'Jost', sans-serif",
                    fontSize: "0.72rem",
                    fontWeight: 500,
                    letterSpacing: "0.14em",
                    textTransform: "uppercase",
                    textDecoration: "none",
                    borderBottom: "1px solid rgba(27, 24, 18, 0.06)",
                } }, link.label))))))));
}
